export enum CustomProductScope {
  REFERENCE = 'reference',
}
